export enum UserCommentRoomStatus {
  PENDING = "pending",
  RESOLVED = "resolved",
}
